import { Locales } from '@/store/language.interface';

export const constant = {
  FormComments: {
    Status: {
      Deleted: 0,
      Active: 1,
    },
    ModerationStatus: {
      Refused: 0,
      Approved: 1,
      Pending: 2,
    },
    Action: {
      like: 1,
      flag: 2,
      dislike: 3,
    },
  },
  Form: {
    Type: {
      Proposal: 1,
      Question: 2,
      OpenQuestion: 3,
      Level: 4,
      Map: 5,
      DotVoting: 6,
    },
    Status: {
      Deleted: 0,
      Approved: 1,
      Pending: 2,
    },
    Map: {
      DefaultMaxVotes: 5,
    },
    DotVoting: {
      MeasurementType: {
        Points: 1,
        Money: 2,
      },
      Type: {
        Fixed: 1,
        Variable: 2,
      },
    },
  },
  Community: {
    Status: {
      Deleted: 0,
      Active: 1,
      PreLaunch: 2,
    },
    CustomPage: {
      About: 1,
      Content: 2,
      Redirect: 3,
    },
  },
  Consultation: {
    Status: {
      PreLaunch: 0,
      Ongoing: 1,
      Completed: 2,
      Archived: 3,
    },
    Type: {
      Public: 1,
      Private: 2,
    },
    ParticipationMode: {
      Open: 1,
      Guided: 2,
    },
    GuidedConsultation: {
      ResultsMode: {
        AllResponses: 1,
        CompletedOnly: 2,
      },
      Visibility: {
        TargetType: { Form: 'form' },
        Operator: { Equals: 'equals' },
      },
    },
  },
  ConsultationResponse: {
    Status: {
      InProgress: 1,
      Completed: 2,
    },
  },
  User: {
    Role: {
      SUPERADMIN: 0,
      ADMIN: 1,
      EDITOR: 2,
      MODERATOR: 3,
      VIEWER: 4,
    },
  },
  Context: {
    Parent: {
      consultation: 1,
      section: 2,
      form: 3,
      module: 4,
      eventItem: 5,
    },
    Type: {
      Text: 1,
      Image: 2,
      Video: 3,
      File: 5,
      Link: 6,
    },
  },
  HomePageItem: {
    Status: {
      PreLaunch: 0,
      Ongoing: 1,
      Completed: 2,
      Archived: 3,
    },
    Type: {
      Consultation: 1,
      Project: 2,
    },
  },
  MailingList: {
    Parent: {
      community: 1,
      consultation: 2,
      project: 3,
    },
    SubscriptionStatus: {
      NewlySubscribed: 1,
      AlreadySubscribed: 2,
      NeedEmailVerification: 3,
    },
  },
  Project: {
    Status: {
      PreLaunch: 0,
      Ongoing: 1,
      Completed: 2,
      Archived: 3,
    },
    Type: {
      Public: 1,
      Private: 2,
    },
  },
  // Mirrors `Page.Status` in api/src/constant/index.js.
  Page: {
    Status: {
      Draft: 1,
      Published: 2,
    },
  },
  // Mirrors `Block` in api/src/constant/index.js. The API is the source of
  // truth: it declares `hosts` per type and enforces them on write, so the
  // clients carry only the values they read.
  Block: {
    Type: {
      Text: 1,
      Video: 2,
      Consultation: 3,
      Attachments: 4,
      FrequentlyAskedQuestions: 5,
      Subscription: 6,
      Timeline: 7,
      ContactList: 8,
      Hero: 9,
      Event: 10,
      News: 11,
      Feedback: 12,
      QuestionAnswer: 13,
      Map: 14,
      DocumentSubmission: 15,
      FeaturedProjects: 16,
      HomepageItems: 17,
      LinksCarousel: 18,
      HomepageHero: 19,
    } as const,
  },
  ProjectModule: {
    QuestionAnswer: {
      Status: {
        Pending: 0,
        Answered: 1,
        Junk: 2,
      },
    },
    DocumentSubmission: {
      Status: {
        Pending: 0,
        Approved: 1,
        Refused: 2,
        Superseded: 3,
      },
      State: {
        Pending: 'pending',
        Published: 'published',
        PublishedWithPendingVersion: 'publishedWithPendingVersion',
        NotPublished: 'notPublished',
        Withdrawn: 'withdrawn',
      } as const,
      Upload: {
        MaxDocumentsPerParticipant: 5,
        MaxVersionsPerDocument: 5,
        MaxFileSize: 25 * 1024 * 1024,
        AllowedMimeTypes: ['application/pdf'],
        MagicBytes: { 'application/pdf': ['%PDF-'] },
        MaxCommentLength: 500,
        MaxTitleLength: 255,
      },
    },
    Alignment: {
      Left: 1,
      Right: 2,
      Center: 3,
    },
    TimelineStep: {
      Status: {
        Upcoming: 1,
        Current: 2,
        Completed: 3,
      },
    },
    EventItem: {
      Status: {
        draft: 1,
        published: 2,
      },
    },
    NewsItem: {
      Status: {
        draft: 1,
        published: 2,
      },
    },
  },
  Pagination: {
    DefaultRowsPerPage: 10,
  },
  EmailRegex:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
  DefaultLocale: 'fr' as Locales,
  FormAnswer: {
    FormState: {
      Question: 1,
      ResultWithStats: 2,
      ResultWithoutStats: 3,
      NoContent: 4,
    },
    ButtonState: {
      NotVoted: 1,
      VotingWithoutAnswers: 2,
      VotingWithAnswers: 3,
      Voted: 4,
    },
  },
};
